import React from "react";
import TicketWindow from "./Tickets/TicketList/TicketWindow";

const TempleGridTickets = () => {
  ///// get tickets
  return (
    <div className="templegrid">
      <div className="templegrid-courtyard-setting">
        TempleGridTickets
        <div>admin user</div>
        <div>logout</div>
        <button>ticket list </button>
        <button>banned account list</button>
        <div>
          reviews
          <button>tickets to review</button>
          <button>reviewed tickets by day / month </button>
          <div>
            <TicketWindow />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TempleGridTickets;
